import angular from 'angular';

import cvtModule from './cvt/cvt';
import iconModule from './icons/icons';

const Components = angular.module('control-room.internal.components', [cvtModule.name, iconModule.name]);

export default Components;
